<template>
  <a-layout class="center-container">
    <!--中间布局 background: '#fff', -->
    <a-layout-content class="center-div"
      :style="{ background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }">

      <!-- 内容详情卡片包裹 -->
      <a-card :hoverable="false" :bordered="true" style="padding: 20px;" :bodyStyle="{ padding: '25px' }"
        :type="'inner'" class="card">

        <div class="about">
          <a-typography-title :level="3">佰特编码 <a-typography-text code> Better
              Coding</a-typography-text></a-typography-title>
          <a-typography-paragraph strong>
            生命不息 编码不止！
          </a-typography-paragraph>
          <a-typography-paragraph>
            我们是IT教育行业的布道者，前沿技术的探索者和传播者！
            <a-typography-text mark>『实战化』和『体系化』</a-typography-text>
            的课程设计，通过紧贴企业实战项目，体系化的提升开发者能力，让开发者专注于
            <a-typography-text strong>编码过程形成学习闭环提升职业技能。</a-typography-text>
          </a-typography-paragraph>

          <a-typography-paragraph>
            我们提供完善的设计原则、最佳实践和开发源码（
            <a-typography-text code>GitHub</a-typography-text>
            和
            <a-typography-text code>Gitee</a-typography-text>
            ），来帮助开发者快速设计开发出高质量的产品原型。
          </a-typography-paragraph>

          <!-- 课程体系 -->
          <a-typography-paragraph>
            <ul>
              <li>
                <a-typography-link href="#">课程体系</a-typography-link>
              </li>
            </ul>
          </a-typography-paragraph>

          <a-typography-paragraph>
            <blockquote>课程范围覆盖：前端\服务端\人工智能\大数据\移动端\系统测试等主流技术，充分满足了职业成长、自我提升等实际需求，帮助开发者实现从技能提升到岗位提升的能力闭环。</blockquote>
            <pre>课程紧贴前沿技术、帮助开发者快速迭代技术体系保持核心竞争力。</pre>
          </a-typography-paragraph>

          <!-- 项目实战 -->
          <a-typography-paragraph>
            <ul>
              <li>
                <a-typography-link href="#">项目实战</a-typography-link>
              </li>
            </ul>
          </a-typography-paragraph>

          <a-typography-paragraph>
            <blockquote>以职业发展为导向的实战课程，边学边练快速进入实操状态提升个人技能，还原企业真实开发场景接轨企业真实技能标准，帮助开发者在技术快速更迭大环境下保持核心竞争力。</blockquote>
            <pre>项目接轨企业实际开发场景、帮助开发者快速拥有企业级实战技能。</pre>
          </a-typography-paragraph>

          <!-- <a-typography-paragraph>
      按
      <a-typography-text keyboard>Esc</a-typography-text>
      键退出阅读……
    </a-typography-paragraph> -->


        </div>

      </a-card>
    </a-layout-content>
    <!-- 底部 -->
    <TheFooter style="margin-top: 0px;"></TheFooter>
  </a-layout>

</template>
<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'About',
  components: {
    TheFooter
  },
  setup() {

    const blockContent = ``;

    onMounted(() => {

    });

    return {
      blockContent
    }
  }
});
</script>
<style scoped>
.about {
  /* padding: 75px 50px 20px 50px; */
  background: white;
}


</style>
